//@flow
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {colors} from '../../../assets/styles/colors';

const useStyles = makeStyles(() => ({
  uploadArea: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: '160px',
    background: colors.grey50,
    borderRadius: '12px',
    border: `2px dashed ${colors.grey300}`,
    gap: '0.75rem',
    color: colors.grey700,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    padding: '1.5rem',
    '&:hover': {
      borderColor: colors.primary,
      backgroundColor: colors.grey100,
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    },
  },
  uploadAreaDragOver: {
    borderColor: `${colors.primary} !important`,
    backgroundColor: `${colors.primary}08 !important`,
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
  },
}));

type Props = {
  onDrop: (files: FileList) => void,
  children: React.Node,
};

export default function DropZone({onDrop, children}: Props) {
  const classes = useStyles();
  const [isOver, setIsOver] = useState(false);

  const handleDragOver = e => {
    e.preventDefault();
    setIsOver(true);
  };

  const handleDragLeave = e => {
    e.preventDefault();
    setIsOver(false);
  };

  const handleDrop = e => {
    e.preventDefault();
    setIsOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      onDrop(files);
    }
  };

  return (
    <div
      className={`${classes.uploadArea} ${
        isOver ? classes.uploadAreaDragOver : ''
      }`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {children}
    </div>
  );
}

// Separate DropZone component for better organization
export function FileDropZone({onDrop, children}: Props) {
  return <DropZone onDrop={onDrop}>{children}</DropZone>;
}
